import { useState } from "react";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import {
  getOrganizationRoleLabel,
  type OrganizationUsersListRow,
} from "@/admin/entities/organizationUsers";
import { EditOrganizationUserRolesDialog } from "./EditOrganizationUserRolesDialog";

interface OrganizationUserRolesCellProps {
  row: OrganizationUsersListRow;
}

// Ячейка колонки "Роли": чипы текущих ролей + кнопка редактирования
export function OrganizationUserRolesCell({
  row,
}: OrganizationUserRolesCellProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Stack
        direction="row"
        spacing={0.5}
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
      >
        {row.roles.map((role) => (
          <Chip
            key={role}
            label={getOrganizationRoleLabel(role)}
            size="small"
          />
        ))}
        <Tooltip title="Изменить роли">
          <IconButton
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              setOpen(true);
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>
      <EditOrganizationUserRolesDialog
        open={open}
        id={row.id}
        roles={row.roles}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
